import { CloseFilled } from '@carbon/icons-react';

import GlobalImageDialog from 'DesignSystem/features/global-images/ImageDialog';
import { ThumbnailFromImageList as Thumbnail } from 'DesignSystem/features/global-images/Thumbnail';
import { Button } from 'DesignSystem/ui/button';
import { cn } from 'DesignSystem/utils';
import { ImageType } from 'pages/global-images/constants';

import { UimDescriptionTooltip } from '../../../shared/uim-description-tooltip';
import { HasRecommendationsNotification, InPendingRequestNotification, SnoozeNotification } from './notifications';

type HeaderProps = {
  clientItemMasterId: string;
  description: string | null;
  mfgId: string | null;
  mfgCatalogId: string | null;
  isActive: boolean;
  inActiveChangeRequest: boolean;
  hasRecommendations: boolean;
  snoozeUntil: string | null;
  uimLongDescription?: string;
  onClose: () => void;
  compact?: boolean;
};
export function ItemHeader(props: HeaderProps) {
  return (
    <div className="relative flex flex-col gap-y-3">
      <Button
        className={cn('absolute -right-4 -top-5 rounded-full', props.compact && '-right-[14px] -top-[23px]')}
        aria-label="close"
        onClick={props.onClose}
        size="icon"
        variant="text"
      >
        <CloseFilled className="h-4 w-4 text-zinc-400" />
      </Button>
      {props.clientItemMasterId ? (
        <div className={cn('flex flex-row items-start justify-start', props.compact ? 'gap-2' : 'space-x-3')}>
          <GlobalImageDialog
            resourceId={props.clientItemMasterId}
            imageType={ImageType.ClientItemMaster}
            description={props.description || 'N/A'}
            mfgId={props.mfgId || '–'}
            isInactive={!props.isActive}
          >
            <Button
              variant="thumbnail"
              size="thumbnail"
              className={cn('bg-white', props.compact && 'size-12 overflow-hidden rounded-[3px] p-[2.667px]')}
            >
              <Thumbnail
                clientItemMasterId={props.clientItemMasterId}
                className={props.compact ? 'size-full' : undefined}
              />
            </Button>
          </GlobalImageDialog>
          <div className={cn(props.compact && 'flex min-w-0 flex-1 flex-col gap-1')}>
            <p
              className={cn(
                'font-m',
                props.compact
                  ? 'type-eyebrow uppercase leading-[11px] tracking-[0.02em] text-indigo-600'
                  : 'type-body-xs leading-4 text-primary-purple'
              )}
            >
              {props.mfgId}
            </p>
            <UimDescriptionTooltip itemDescription={props.description} uimLongDescription={props.uimLongDescription}>
              <p
                className={cn(
                  'cursor-default text-[17px]',
                  props.compact ? 'font-m leading-[22px] text-[rgba(0,0,0,0.85)]' : 'leading-5'
                )}
              >
                {props.description ?? '–'}
              </p>
            </UimDescriptionTooltip>
          </div>
        </div>
      ) : (
        <div className="mr-6">
          <p className="type-body-xs font-m leading-4 text-primary-purple">{props.mfgCatalogId}</p>
          <UimDescriptionTooltip itemDescription={props.description} uimLongDescription={props.uimLongDescription}>
            <p className="cursor-default text-[17px]/5">{props.description ?? '–'}</p>
          </UimDescriptionTooltip>
        </div>
      )}
      {props.inActiveChangeRequest ? <InPendingRequestNotification /> : null}
      {props.hasRecommendations ? <HasRecommendationsNotification /> : null}
      {props.snoozeUntil ? (
        <SnoozeNotification
          snoozeUntil={props.snoozeUntil}
          preferenceCardClientItemMasterId={props.clientItemMasterId}
        />
      ) : null}
    </div>
  );
}
